import moment from 'src/services/moment_instance';

export const SERVICES_PATH = '/admin/church-services';
export const NEW_SERVICE_PATH = `${SERVICES_PATH}/new`;
export const editServicePath = (id) => `${SERVICES_PATH}/${id}/edit`;

export const QUESTION_TYPES = [
  { key: 'text', value: 'text', text: 'Respuesta abierta' },
  { key: 'number', value: 'number', text: 'Número' },
];

let questionSeq = 0;

export const newExtraQuestion = () => ({
  id: `question_${++questionSeq}`,
  label: '',
  type: 'text',
  mandatory: false,
});

export const getEffectiveSlugname = (inputs = {}) =>
  inputs.newEventSlugname || inputs.eventSlugname || '';

export const isPaidService = (inputs) => getEffectiveSlugname(inputs).includes('.');

export const extraQuestionsFromEvent = (extraInfo = []) =>
  (extraInfo || []).map((extra) => ({
    ...newExtraQuestion(),
    label: extra.label || extra.name?.replace(/_\d+$/, '').replace(/_/g, ' ') || '',
    type: extra.type || 'text',
    mandatory: Boolean(extra.mandatory),
    name: extra.name,
  }));

// Existing questions keep their stored `name` so previously collected answers stay linked.
export const buildExtraInfo = (questions = []) => {
  const usedNames = new Set(questions.map((q) => q.name).filter(Boolean));

  return questions
    .filter((question) => question.label?.trim())
    .map((question, index) => {
      const label = question.label.trim();
      let name = question.name;

      if (!name) {
        const base = `${label.replace(/ /g, '_')}_${index + 1}`;
        name = base;
        for (let n = 2; usedNames.has(name); n++) name = `${base}_${n}`;
        usedNames.add(name);
      }

      return { label, name, type: question.type || 'text', mandatory: Boolean(question.mandatory) };
    });
};

export const serviceToFormInputs = (service) => {
  const { AuditoriumGuests, ...event } = service;
  const additionalinformation = service.additionalinformation || {};
  const notificationsData = service.notificationsData || {};
  const extraQuestions = extraQuestionsFromEvent(additionalinformation.extraInfo);

  return {
    ...event,
    ...additionalinformation,
    extraInfo: extraQuestions.length > 0,
    extraQuestions,
    time: moment.tz(service.date, 'America/Bogota').format('HH:mm'),
    templateId: notificationsData.templateId,
    listId: notificationsData.listId,
    whatsappTemplate: notificationsData.whatsappTemplate,
    sendmail: Boolean(notificationsData.templateId || notificationsData.listId),
    sendwhatsapp: Boolean(notificationsData.whatsappTemplate),
  };
};

export const buildServicePayload = (inputs, eventId) => {
  const { extraQuestions, extraInfo: askExtraInfo, ...rest } = inputs;

  return {
    ...rest,
    ...(eventId ? { event_id: eventId } : {}),
    eventSlugname: getEffectiveSlugname(rest),
    date: `${moment(rest.date).format('YYYY-MM-DD')} ${rest.time} -05:00`,
    additionalinformation: {
      extraInfo: askExtraInfo ? buildExtraInfo(extraQuestions) : [],
      confirmDataInfo: rest.confirmDataInfo,
      summaryInfo: rest.summaryInfo,
    },
  };
};
